export default __webpack_public_path__ + "static/media/json.cb64f686.png";